/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {CreatePresetRequest} from '../models/CreatePresetRequest';
import type {CreatePresetResponse} from '../models/CreatePresetResponse';
import type {DeletePresetRequest} from '../models/DeletePresetRequest';
import type {Error} from '../models/Error';
import type {PresetItem} from '../models/PresetItem';
import type {PresetPage} from '../models/PresetPage';
import type {PresetRelationItem} from '../models/PresetRelationItem';
import type {UpdatePresetRequest} from '../models/UpdatePresetRequest';

export interface CreatePreset$Request {
    createPresetRequest: CreatePresetRequest;
}

export interface CreatePreset$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const createPresetRequest = createAction<PayloadData<void, CreatePreset$Request>>('ENTITLEMENTS_PRESET__CREATE_PRESET__REQUEST');
export const createPresetSuccess = createAction<PayloadData<CreatePresetResponse, CreatePreset$Request>>('ENTITLEMENTS_PRESET__CREATE_PRESET__SUCCESS');
export const createPresetFailure = createAction<PayloadData<Error, CreatePreset$Request, true>>('ENTITLEMENTS_PRESET__CREATE_PRESET__FAILURE');

export const createPresetActions = [
    createPresetRequest,
    createPresetSuccess,
    createPresetFailure
] as const;

/**
 * @param {CreatePresetRequest} meta.createPresetRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const createPreset = (meta: CreatePreset$Request, config?: CreatePreset$Config) => {
    return {
        CALL_API: {
            types: createPresetActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/entitlements/presets`,
            TRANSPORT_REQUEST_BODY: meta.createPresetRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetPreset$Request {
    presetId: string;
}

export interface GetPreset$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getPresetRequest = createAction<PayloadData<void, GetPreset$Request>>('ENTITLEMENTS_PRESET__GET_PRESET__REQUEST');
export const getPresetSuccess = createAction<PayloadData<PresetItem, GetPreset$Request>>('ENTITLEMENTS_PRESET__GET_PRESET__SUCCESS');
export const getPresetFailure = createAction<PayloadData<Error, GetPreset$Request, true>>('ENTITLEMENTS_PRESET__GET_PRESET__FAILURE');

export const getPresetActions = [
    getPresetRequest,
    getPresetSuccess,
    getPresetFailure
] as const;

/**
 * @param {string} meta.presetId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getPreset = (meta: GetPreset$Request, config?: GetPreset$Config) => {
    return {
        CALL_API: {
            types: getPresetActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/entitlements/preset/${meta.presetId}`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetPresets$Request {
    pageNumber: number;
    pageSize: number;
}

export interface GetPresets$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getPresetsRequest = createAction<PayloadData<void, GetPresets$Request>>('ENTITLEMENTS_PRESET__GET_PRESETS__REQUEST');
export const getPresetsSuccess = createAction<PayloadData<PresetPage, GetPresets$Request>>('ENTITLEMENTS_PRESET__GET_PRESETS__SUCCESS');
export const getPresetsFailure = createAction<PayloadData<Error, GetPresets$Request, true>>('ENTITLEMENTS_PRESET__GET_PRESETS__FAILURE');

export const getPresetsActions = [
    getPresetsRequest,
    getPresetsSuccess,
    getPresetsFailure
] as const;

/**
 * @param {number} meta.pageNumber
 * @param {number} meta.pageSize
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getPresets = (meta: GetPresets$Request, config?: GetPresets$Config) => {
    const TRANSPORT_GET_PARAMS = {
        pageNumber: meta.pageNumber,
        pageSize: meta.pageSize,
    };
    return {
        CALL_API: {
            types: getPresetsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/entitlements/presets`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetPresetsRelation$Request {
    presetIds: Array<string>;
}

export interface GetPresetsRelation$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getPresetsRelationRequest = createAction<PayloadData<void, GetPresetsRelation$Request>>('ENTITLEMENTS_PRESET__GET_PRESETS_RELATION__REQUEST');
export const getPresetsRelationSuccess = createAction<PayloadData<{ [key: string]: Array<PresetRelationItem>; }, GetPresetsRelation$Request>>('ENTITLEMENTS_PRESET__GET_PRESETS_RELATION__SUCCESS');
export const getPresetsRelationFailure = createAction<PayloadData<Error, GetPresetsRelation$Request, true>>('ENTITLEMENTS_PRESET__GET_PRESETS_RELATION__FAILURE');

export const getPresetsRelationActions = [
    getPresetsRelationRequest,
    getPresetsRelationSuccess,
    getPresetsRelationFailure
] as const;

/**
 * @param {Array<string>} meta.presetIds
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getPresetsRelation = (meta: GetPresetsRelation$Request, config?: GetPresetsRelation$Config) => {
    const TRANSPORT_GET_PARAMS = {
        presetIds: meta.presetIds,
    };
    return {
        CALL_API: {
            types: getPresetsRelationActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/entitlements/presets`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface RemovePreset$Request {
    presetId: string;
    deletePresetRequest: DeletePresetRequest;
}

export interface RemovePreset$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const removePresetRequest = createAction<PayloadData<void, RemovePreset$Request>>('ENTITLEMENTS_PRESET__REMOVE_PRESET__REQUEST');
export const removePresetSuccess = createAction<PayloadData<void, RemovePreset$Request>>('ENTITLEMENTS_PRESET__REMOVE_PRESET__SUCCESS');
export const removePresetFailure = createAction<PayloadData<Error, RemovePreset$Request, true>>('ENTITLEMENTS_PRESET__REMOVE_PRESET__FAILURE');

export const removePresetActions = [
    removePresetRequest,
    removePresetSuccess,
    removePresetFailure
] as const;

/**
 * @param {string} meta.presetId
 * @param {DeletePresetRequest} meta.deletePresetRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const removePreset = (meta: RemovePreset$Request, config?: RemovePreset$Config) => {
    return {
        CALL_API: {
            types: removePresetActions,
            method: ApiMethods.DELETE,
            endpoint: `/web-api/entitlements/preset/${meta.presetId}`,
            TRANSPORT_REQUEST_BODY: meta.deletePresetRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface UpdatePreset$Request {
    presetId: string;
    updatePresetRequest: UpdatePresetRequest;
}

export interface UpdatePreset$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const updatePresetRequest = createAction<PayloadData<void, UpdatePreset$Request>>('ENTITLEMENTS_PRESET__UPDATE_PRESET__REQUEST');
export const updatePresetSuccess = createAction<PayloadData<void, UpdatePreset$Request>>('ENTITLEMENTS_PRESET__UPDATE_PRESET__SUCCESS');
export const updatePresetFailure = createAction<PayloadData<Error, UpdatePreset$Request, true>>('ENTITLEMENTS_PRESET__UPDATE_PRESET__FAILURE');

export const updatePresetActions = [
    updatePresetRequest,
    updatePresetSuccess,
    updatePresetFailure
] as const;

/**
 * @param {string} meta.presetId
 * @param {UpdatePresetRequest} meta.updatePresetRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const updatePreset = (meta: UpdatePreset$Request, config?: UpdatePreset$Config) => {
    return {
        CALL_API: {
            types: updatePresetActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/entitlements/preset/${meta.presetId}`,
            TRANSPORT_REQUEST_BODY: meta.updatePresetRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

